import {Directive, EventEmitter, HostListener, Output} from "@angular/core";
import {ExcFileItem} from "../models/ExcFileItem";

/**
 * A directive to provide a fast and straightforward possibility to upload one or more files.
 */
@Directive({
  selector: '[excDirectUpload]'
})
export class ExcDirectUploadDirective {

  @Output('change') private changeEmitter: EventEmitter<ExcFileItem[]> = new EventEmitter();

  /**
   * On click listener that shows the file picker dialog
   */
  @HostListener('click')
  showFilePicker() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = true;
    fileInput.addEventListener("change", () => this.processFileList(fileInput.files))
    fileInput.click();
  }

  /**
   * Processed the fileList object that was created through the file picker dialog. This function
   * emits a change event after the files have been loaded into memory.
   * @param fileList - a list of files that should be processed
   */
  private async processFileList(fileList: FileList) {
    const files = [];
    const promises = [];

    for(let i = 0; i < fileList.length; i++){
      const excFile = ExcFileItem.fromFile(fileList[i]);
      files.push(excFile);
      promises.push(excFile.afterLoading.toPromise())
    }
    await Promise.all(promises);
    this.changeEmitter.emit(files)
  }
}
